import CargoLinesForm from '../../../../components/Purchasing/Cargo/Lines/CargoLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function CargoLinesModal (props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isUpdatable,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Cargo Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <CargoLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

CargoLinesModal.propTypes = {}
CargoLinesModal.defaultProps = {}

export default CargoLinesModal
